var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-contract-pdf" },
    [
      _vm.list.length == 0
        ? _c("div", { staticClass: "list-none" }, [_vm._v("暂无附件")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.list, function (item, index) {
        return _c("div", { key: index, staticClass: "item" }, [
          _c("a", { attrs: { href: item.pic_path } }, [
            _vm._v(_vm._s(index + 1) + ".合同附件" + _vm._s(index + 1)),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }